import { createContext, useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { profileData } from "../../api/userApi";

export const AuthContext = createContext(null);

export const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["authProfile"],
    queryFn: profileData,
    staleTime: 5 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchInterval: 10 * 60 * 1000,
  });

  useEffect(() => {
    setUserData(data?.data);
  }, [data]);
  const [userData, setUserData] = useState(data?.data);
  console.log(userData);

  const access_token = localStorage.getItem("access_token");
  const refresh_token = localStorage.getItem("refresh_token");

  useEffect(() => {
    if (!access_token || !refresh_token) {
      navigate("/auth/login");
      console.log("NO TOKEEEN");
    }
  }, [access_token, refresh_token, navigate]);

  useEffect(() => {
    if (isError || (!data && isLoading === false)) {
      navigate("/auth/login");
      console.log("SERVEREROOR");
    }
  }, [isLoading]);

  console.log("PRIVATEROUTE", data);

  return (
    <AuthContext.Provider
      value={{
        setUserData,
        userData,
        isLoading,
        isAuthenticated: !!data && !isError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
